import {
    Component,
    ElementRef,
    Input,
    OnChanges,
    SimpleChanges,
    ViewChild,
    forwardRef
} from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { NgSelectComponent } from '@ng-select/ng-select'
import { Empresa } from '../../pkw-data/core/empresa.model'

const EMPTY_VALUE = undefined

@Component({
    selector: 'col-empresa-select',
    templateUrl: './empresa-select.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EmpresaSelectComponent),
            multi: true
        }
    ]
})
export class EmpresaSelectComponent implements OnChanges, ControlValueAccessor {
    @Input() empresas: Empresa[]
    @Input() placeholder?: string
    @Input() multiple?: boolean
    @Input() allowClear?: boolean
    @Input() todasEmpresasOption?: boolean

    @ViewChild('searchBox') searchBox: ElementRef
    @ViewChild(NgSelectComponent) select: NgSelectComponent

    selected: Empresa
    empresasOptions: Empresa[]
    disabled: boolean

    private todasEmpresasOptionObj: Empresa
    private onChange: any
    private onTouched: any

    ngOnChanges(changes: SimpleChanges) {
        this.handleInputChanges(changes)
    }

    search(text: string) {
        this.select.filter(text)
    }

    emitChange() {
        if (
            this.todasEmpresasOption &&
            this.selected &&
            this.selected.id === this.todasEmpresasOptionObj.id
        ) {
            this.onChange(EMPTY_VALUE)
        } else {
            this.onChange(this.selected)
        }
    }

    writeValue(obj: any) {
        if (obj === EMPTY_VALUE && this.todasEmpresasOption) {
            this.selected = this.todasEmpresasOptionObj
        } else {
            this.selected = obj
        }
    }

    registerOnChange(fn: any) {
        this.onChange = fn
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn
    }

    setDisabledState?(isDisabled: boolean) {
        this.disabled = isDisabled
    }

    onClose() {
        this.onTouched()
    }

    onBlur() {
        if (!this.searchBox) {
            this.onTouched()
        }
    }

    focusSearchBox() {
        setTimeout(() => {
            this.searchBox.nativeElement.focus()
        })
    }

    empresaFilter(term: string, empresa: Empresa) {
        const nome = empresa.nomeComposto.toLowerCase()
        const nomeFantasia = empresa.nomeFantasia && empresa.nomeFantasia.toLowerCase()
        const contentStr = `${nome}\n${nomeFantasia}`
        term = term.toLowerCase()
        return contentStr.indexOf(term) > -1
    }

    private handleInputChanges(changes: SimpleChanges) {
        if (changes.empresas) {
            this.empresasOptions = (this.empresas || []).slice()
        }

        if (changes.todasEmpresasOption) {
            if (this.todasEmpresasOption) {
                this.todasEmpresasOptionObj = new Empresa(undefined)
                this.todasEmpresasOptionObj.id = 'empty'
                this.todasEmpresasOptionObj.nome = 'Todas as empresas'
                this.todasEmpresasOptionObj.nomeFantasia = 'Todas'
                this.empresasOptions.unshift(this.todasEmpresasOptionObj)
            } else if (this.todasEmpresasOptionObj) {
                this.empresasOptions.shift()
                this.todasEmpresasOptionObj = undefined
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/empresa-select/empresa-select.component.ts